import React from 'react';
import AppQuiz from './components/AppQuiz';
import { AnimatePresence, motion } from 'framer-motion';
import { usePxToVw } from '../../../hooks/usePxToVw';
const QuizDisplay = ({
  topicquestions,
  triviaQuizSettings,
  brandColor,
  backToMenu,
  brandFont,
  selectedTopicId,
  currentUserId,
}) => {
  const { pxToVw, getMaxWidth } = usePxToVw();
  return (
    <div>
      <div className="corner-overlays-responsive">
        <AnimatePresence mode="wait">
          <motion.div
            className="corner-item top-left"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ justifyContent: 'left' }}
          >
            <img
              src={triviaQuizSettings?.leftTop?.fileUrl}
              alt="Logo"
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: getMaxWidth('25vw'),
                display: triviaQuizSettings?.leftTop?.enabled ? 'block' : 'none',
                // height: "130px",
              }}
            />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div
            className="corner-item top-right"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ justifyContent: 'right' }}
          >
            <img
              src={triviaQuizSettings?.rightTop?.fileUrl}
              alt="Logo"
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: getMaxWidth('25vw'),
                display: triviaQuizSettings?.rightTop?.enabled ? 'block' : 'none',
                // height: "130px",
              }}
            />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div
            className="corner-item bottom-right"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ justifyContent: 'right' }}
          >
            <img
              src={triviaQuizSettings?.rightBottom?.fileUrl}
              alt="Logo"
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: getMaxWidth('25vw'),
                display: triviaQuizSettings?.rightBottom?.enabled ? 'block' : 'none',
                // height: "130px",
              }}
            />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div
            className="corner-item bottom-left"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ justifyContent: 'left' }}
          >
            <img
              src={triviaQuizSettings?.leftBottom?.fileUrl}
              alt="Logo"
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: getMaxWidth('25vw'),
                display: triviaQuizSettings?.leftBottom?.enabled ? 'block' : 'none',
                // height: "130px",
              }}
            />
          </motion.div>
        </AnimatePresence>
      </div>
      <AppQuiz
        topicquestions={topicquestions}
        triviaQuizSettings={triviaQuizSettings}
        brandColor={brandColor}
        backToMenu={backToMenu}
        brandFont={brandFont}
        selectedTopicId={selectedTopicId}
        currentUserId={currentUserId}
      />
    </div>
  );
};

export default QuizDisplay;
